import React, { createContext, useState, ReactNode, useCallback } from 'react';

type ToastType = 'success' | 'error' | 'info';

interface ToastMessage {
    id: number;
    title: string;
    message: string;
    type: ToastType;
}

interface ToastContextType {
    toast: ToastMessage | null;
    showToast: (title: string, message: string, type?: ToastType) => void;
    hideToast: () => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [toast, setToast] = useState<ToastMessage | null>(null);

    const showToast = useCallback((title: string, message: string, type: ToastType = 'info') => {
        setToast({ id: Date.now(), title, message, type });
    }, []);

    const hideToast = useCallback(() => {
        setToast(null);
    }, []);

    return (
        <ToastContext.Provider value={{ toast, showToast, hideToast }}>
            {children}
        </ToastContext.Provider>
    );
};
